<div class="claims-wrapper">
  <div class="claims-header" (click)="goBack()">
    <img src="../../../../assets/images/arrow-right.png" alt="">
    Add Family Member Details
  </div>
  <div class="error-msg" *ngFor="let error of errorList">
    <p>{{ error.message }}</p>
  </div>
  <div class="claims-body">
    <div class="top">Please provide the required information to add a family member to your policy.</div>
    <div class="bottom">
      <form [formGroup]="form">
        <div class="form-group" *ngIf="addMemberOrDependent === 'addMemberByHr'">
          <label class="label">Policy No:<sup>*</sup></label>
          <!-- <input type="text" class="form-control" formControlName="policyNo" /> -->
          <div class="dropdown input">
            <button class="btn my-0 dropdown-toggle text-left w-100" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="true">
              <span *ngIf="currentPolicyChosen === null">Select policy</span>
              <span *ngIf="currentPolicyChosen !== null && currentPolicyChosen.isActive" class="logged"></span>
              <span *ngIf="currentPolicyChosen !== null && !currentPolicyChosen.isActive" class="notLogged"></span>
              <span *ngIf="currentPolicyChosen !== null"> {{ currentPolicyChosen.policyNumber }}</span>
            </button>
            <div class="dropdown-menu dropdown-menu-right w-100">
              <div *ngFor="let policy of policies" (click)="policyChanged(policy)">
                <a class="dropdown-item" *ngIf="policy.isActive">
                  <span *ngIf="policy.isActive" class="logged"></span>
                  <span *ngIf="!policy.isActive" class="notLogged"></span>
                  <span> {{ policy.policyNumber }}</span>
                </a>
              </div>
            </div>
          </div>
          <span class="error-msg small"
            *ngIf="form.get('policyNo').dirty && form.get('policyNo').status === 'INVALID'">Invalid Policy Number <i
              class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </span>
        </div>
        <div class="form-group" *ngIf="addMemberOrDependent === 'addDependentByMember'">
          <label class="label">Policy No:<sup>*</sup></label>
          <input type="text" placeholder="Enter Policy No." name="" class="form-control input" disabled
            formControlName="policyNo" />
        </div>
        <div class="form-group" *ngIf="addMemberOrDependent === 'addMemberByHr'">
          <label class="label">Employee Id:<sup>*</sup></label>
          <input type="text" placeholder="Enter Employee Id" class="form-control input" formControlName="employeeId" />
          <span class="error-msg small"
            *ngIf="form.get('employeeId').dirty && form.get('employeeId').status === 'INVALID'">Invalid Employee Id <i
              class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </span>
        </div>
        <div class="form-group" *ngIf="addMemberOrDependent === 'addDependentByMember'">
          <label class="label">Employee Id:<sup>*</sup></label>
          <input type="text" placeholder="Enter Employee Id" name="" class="form-control input" formControlName="employeeId" />
        </div>
        <div class="form-group">
          <label class="label">Family Member Name:<sup>*</sup></label>
          <input type="text" placeholder="Enter Full Name" class="form-control input" formControlName="insuredName" />
          <span class="error-msg small"
            *ngIf="form.get('insuredName').dirty && form.get('insuredName').status === 'INVALID'">Invalid Insured Name
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </span>
        </div>
        <div class="form-group">
          <label class="label">
            Gender:<sup>*</sup>
          </label>
        
          <div class="gender-wrapper">
        
            <label class="gender-box">
              <input 
                type="radio"
                formControlName="gender"
                value="M">
              <span class="radio-custom"></span>
              <span class="gender-text">Male</span>
            </label>
        
            <label class="gender-box">
              <input 
                type="radio"
                formControlName="gender"
                value="F">
              <span class="radio-custom"></span>
              <span class="gender-text">Female</span>
            </label>
        
          </div>
        
          <span class="error-msg small"
                *ngIf="form.get('gender')?.dirty && form.get('gender')?.invalid">
                Gender is required
          </span>
        </div>
        <!-- <div class="form-group">
          <label class="label">Gender:<sup>*</sup></label>
          <select name="" class="form-control input" formControlName="gender">
            <option value="" disabled selected hidden>Select gender from dropdown</option>
            <option value="M">Male</option>
            <option value="F">Female</option>
          </select>
        </div> -->
        <div class="form-group">
          <label class="label">Mobile No:<sup>*</sup></label>
          <input type="tel" inputmode="numeric" maxlength="10" pattern="[0-9]*"
            placeholder="Enter Mobile Number" class="form-control input" formControlName="mobileNo" />
          <span class="error-msg small"
            *ngIf="form.get('mobileNo').dirty && form.get('mobileNo').status === 'INVALID'">Invalid Mobile Number<i
              class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </span>
        </div>
        <!-- <div class="form-group">
          <label class="label">Location:</label>
          <input type="text" class="form-control input" placeholder="Enter Location" formControlName="location" />
          <span class="error-msg small"
            *ngIf="form.get('location').dirty && form.get('location').status === 'INVALID'">Invalid Location <i
              class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </span>
        </div> -->
        <div class="form-group" *ngIf="addMemberOrDependent !== 'addMemberByHr'">
          <label class="label">Relationship With Insured:<sup>*</sup></label>
          <select name="" class="form-control input" formControlName="relationship" (change)="relationshipChanged()">
            <!-- <option  value="" disabled selected hidden>Select relationship with policyholder</option> -->
            <option *ngFor="let relation of relationships" [value]="relation[0]">{{ relation[0] }}</option>
          </select>
        </div>
        <div class="form-group" *ngIf="addMemberOrDependent === 'addMemberByHr'">
          <label class="label">Relationship With Insured:<sup>*</sup></label>
          <!-- <option  value="" disabled selected hidden>Select relationship with policyholder</option> -->
          <input type="text" name="" class="form-control input" disabled formControlName="relationship" />
        </div>
        <!-- <div class="form-group">
          <label class="label">Sum Insured:</label>
          <input type="number" placeholder="Enter Sum Insured" (keypress)="numberOnly($event)"
            class="form-control input" formControlName="sumInsured" />
          <span class="error-msg small"
            *ngIf="form.get('sumInsured').dirty && form.get('sumInsured').status === 'INVALID'">Invalid Sum Insured <i
              class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </span>
        </div> -->
        <div class="form-group">
          <label class="label">Email ID:</label>
          <input type="text" class="form-control input" placeholder="Enter Email ID" formControlName="email" />
          <span class="error-msg small"
            *ngIf="form.get('email').dirty && form.get('email').status === 'INVALID'">Invalid
            Email Id <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </span>
        </div>
        <div class="form-group" *ngIf="addMemberOrDependent === 'addMemberByHr'">
          <label class="label">Grade:</label>
          <input type="text" class="form-control input" placeholder="Enter Grade" formControlName="grade" />
          <span class="error-msg small"
            *ngIf="form.get('grade').dirty && form.get('grade').status === 'INVALID'">Invalid
            Grade <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </span>
        </div>
        <div class="form-group">
          <label class="label">Date Of Birth:<sup>*</sup></label>
          <input value="{{ date | date: 'dd MMMM yyyy' }}" type="text" placeholder="Enter Date of Birth"
            class="form-control input" readonly bsDatepicker [maxDate]="date"
            [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD MMMM YYYY', adaptivePosition: true,containerClass: 'theme-dark-blue', showWeekNumbers: false }"
            formControlName="dob" />
        </div>
        <!-- <div class="form-group">
          <label class="label">Endorsement Type:<sup>*</sup></label>
          <select name="" disabled class="form-control input" formControlName="endorsementType">
             <option value=""  selected >Select Endorsement Type</option>
            <option value="Addition" selected>ADDITION</option>
            <option value="Modification">MODIFICATION</option>
            <option value="Deletion">DELETION</option>
            <option value="FreshEnrollement">FRESH ENROLLMENT</option>
          </select>
        </div> -->
        <!-- <div class="form-group" *ngIf="isTopUpSumInsured">
          <label class="label">TopUp Sum Insured:</label>
          <input type="number" (keypress)="numberOnly($event)" placeholder="Enter TopUp Sum Insured"
            class="form-control input" formControlName="topupSI" />
          <span class="error-msg small"
            *ngIf="form.get('topupSI').dirty && form.get('topupSI').status === 'INVALID'">Invalid Topup Sum Insured <i
              class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </span>
        </div> -->
        <div class="form-group" *ngIf="addMemberOrDependent === 'addMemberByHr'">
          <label class="label">Designation:</label>
          <input type="text" class="form-control input" formControlName="designation" />
          <span class="error-msg small"
            *ngIf="form.get('designation').dirty && form.get('designation').status === 'INVALID'">Invalid Designation<i
              class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </span>
        </div>
        <!-- <div class="form-group">
          <label class="label">Elite:</label>
          <input type="text" class="form-control input" formControlName="elite" />
          <span class="error-msg small"
            *ngIf="form.get('elite').dirty && form.get('elite').status === 'INVALID'">Invalid
            Elite <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </span>
        </div> -->
        <!-- <div class="form-group">
          <label class="label">UHID:</label>
          <input type="text" class="form-control input" formControlName="uhid" />
          <span class="error-msg small" *ngIf="form.get('uhid').dirty && form.get('uhid').status === 'INVALID'">Invalid
            UHID
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </span>
        </div> -->
      </form>
    </div>

        <!--Date Modal-->
        <div id="submit_Popup" class="modal "  tabindex="-1" role="dialog"
        aria-labelledby="submit_Popup" aria-hidden="true" data-keyboard="false">
        <div class="modal-dialog  modal-dialog-centered">
          <div class="modal-content">
            <!-- <div class="modal-header">
               <h5 class="modal-title">Intimate {{ intimationType }}<small></small></h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="OK()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div> -->
            <div class="modal-body">
              <div class="container-fluid">
                <div class="form-group center-bull">
                  <!-- Modal body -->
                   <img src="../../../../assets/images/notif-bull.png" alt="">
                  <div class="modal-body" *ngIf="validForm">
                    Your family member addition request has been received and will be processed within 24 working hours, pending approval
                    (*applicable for Megastar tier only*)
                  </div>
                  <div class="modal-body" *ngIf="!validForm">
                    Please fill the Mandotry Fields 
                  </div>
                  <div class="modal-body" *ngIf="isLoading">
                    Submitting Form Please Wait....
                  </div>
                <div style="text-align: center;">
                  <button (click)="OK()" data-dismiss="modal" type="button"
                    class="btn btn-secondary applybutton">Ok</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

  </div>

</div>

<div class="start-tarack-claim-wrapper" >
  <div class="button-text" data-toggle="modal" data-target="#submit_Popup" (click)="save($event)">Submit</div>
</div>